import { isAxiosError } from "axios";

export const isAiInsufficientPointsError = (error: unknown) =>
  isAxiosError<{ code?: string }>(error) &&
  error.response?.status === 402 &&
  error.response.data?.code === "AI_INSUFFICIENT_POINTS";
